import { useState, useEffect } from "react";
import './FaceSelector.scss'

const FaceSelector = (props) => {
  const [IsChecked, setIsChecked] = useState(false);

  useEffect(() => {
    setIsChecked(props.isSelected);
  }, [props.isSelected]);

  const handleSelection = () => {
    props.OnSelect();
  };

  return (
    <div
      className={IsChecked ? "face-select-circle active" : "face-select-circle"}
      onClick={handleSelection}
      style={props.style}
    ></div>
  );
};

export default FaceSelector;
